import React from "react";
import {
  AppBar,
  Toolbar,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  useMediaQuery,
  Typography,
} from "@mui/material";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import {
  EARNING_ACTIVE,
  EARNING_INACTIVE,
  HOME_ACTIVE,
  HOME_INACTIVE,
  PROFILE_ACTIVE,
  PROFILE_INACTIVE,
  TRACK_ACTIVE,
  TRACK_INACTIVE,
  BACK_ICON, // Add a back icon for mobile navigation
} from "../assets/icons/Icons";
import Routes from "../utils/Routes";

const NavContainer = styled(AppBar)({
  background: "#E5EEE7",
  boxShadow: "none",
  padding: "10px",
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1000,
});

const StyledNavLink = styled(NavLink)({
  textDecoration: "none",
  color: "black",
  margin: "0 15px",
  fontSize: "18px",
  "&.active": {
    fontWeight: "bold",
    color: "white",
    background: "darkgreen",
    padding: "5px 15px",
    borderRadius: "20px",
  },
});

const StyledBottomNav = styled(BottomNavigation)({
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: "#203C00",
  zIndex: 1000,
  display: "flex",
  justifyContent: "space-between",
  padding: "5px 10px",
});

const BottomNavigationBtn = styled(BottomNavigationAction)({
  color: "white",
  minWidth: "60px",
  "&.Mui-selected": {
    color: "white",
  },
  "& .MuiBottomNavigationAction-label": {
    fontWeight: "bold",
    fontFamily: "Poppins",
    fontSize: 12,
    letterSpacing: 0,
    textAlign: "center",
  },
});

const StyledIcon = styled("img")({
  maxWidth: "28px",
  maxHeight: "28px",
  objectFit: "contain",
});

const MobileHeader = styled(AppBar)({
  backgroundColor: "#203C00",
  boxShadow: "none",
  height: "56px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1000,
});

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const pageTitles = {
    ["/" + Routes.Home]: "Home",
    ["/" + Routes.Track]: "Track",
    ["/" + Routes.Earning]: "Earnings",
    ["/" + Routes.Profile]: "Profile",
  };

  const handleNavClick = (route) => {
    if (location.pathname === "/" + route) {
      navigate(0); // Refresh page if already on the same route
    } else {
      navigate("/" + route);
    }
  };

  return (
    <Box>
      {/* Mobile Header with Page Titles */}
      {isMobile && (
        <MobileHeader position="static">
          <Toolbar sx={{ justifyContent: "center" }}>
            <Typography
              variant="h6"
              sx={{ color: "white", fontWeight: "bold" }}
            >
              {pageTitles[location.pathname] || "Home"}
            </Typography>
          </Toolbar>
        </MobileHeader>
      )}

      {/* Desktop Navigation */}
      {!isMobile && (
        <NavContainer position="static">
          <Toolbar sx={{ justifyContent: "center" }}>
            <StyledNavLink
              to={"/" + Routes.Home}
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={() => handleNavClick(Routes.Home)}
            >
              Home
            </StyledNavLink>
            <StyledNavLink
              to={"/" + Routes.Track}
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={() => handleNavClick(Routes.Track)}
            >
              Track
            </StyledNavLink>
            <StyledNavLink
              to={"/" + Routes.Earning}
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={() => handleNavClick(Routes.Earning)}
            >
              Earnings
            </StyledNavLink>
            <StyledNavLink
              to={"/" + Routes.Profile}
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={() => handleNavClick(Routes.Profile)}
            >
              Profile
            </StyledNavLink>
          </Toolbar>
        </NavContainer>
      )}

      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <StyledBottomNav showLabels value={location.pathname}>
          <BottomNavigationBtn
            label="Home"
            icon={
              <StyledIcon
                src={
                  location.pathname === "/" + Routes.Home
                    ? HOME_ACTIVE
                    : HOME_INACTIVE
                }
                alt="Home"
              />
            }
            onClick={() => handleNavClick(Routes.Home)}
          />
          <BottomNavigationBtn
            label="Track"
            icon={
              <StyledIcon
                src={
                  location.pathname === "/" + Routes.Track
                    ? TRACK_ACTIVE
                    : TRACK_INACTIVE
                }
                alt="Track"
              />
            }
            onClick={() => handleNavClick(Routes.Track)}
          />
          <BottomNavigationBtn
            label="Earnings"
            icon={
              <StyledIcon
                src={
                  location.pathname === "/" + Routes.Earning
                    ? EARNING_ACTIVE
                    : EARNING_INACTIVE
                }
                alt="Earning"
              />
            }
            onClick={() => handleNavClick(Routes.Earning)}
          />
          <BottomNavigationBtn
            label="Profile"
            icon={
              <StyledIcon
                src={
                  location.pathname === "/" + Routes.Profile
                    ? PROFILE_ACTIVE
                    : PROFILE_INACTIVE
                }
                alt="Profile"
              />
            }
            onClick={() => handleNavClick(Routes.Profile)}
          />
        </StyledBottomNav>
      )}
    </Box>
  );
};

export default Navigation;
